export default __webpack_public_path__ + "static/media/medicenter-about-us.4359b78a.PNG";